// Parody website data — A Profit Dynamics International™ Production

export const PARODY_SITES = {
  portal: {
    name: 'The Information Superhighway',
    url: 'http://www.infosuperhighway.net',
  },
  youtoob: {
    name: 'YouBoob',
    url: 'http://www.youboob.com',
  },
  myface: {
    name: 'FaceLeak',
    url: 'http://www.faceleak.com',
  },
  winampgalaxy: {
    name: 'WinScam Galaxy',
    url: 'http://www.winscamgalaxy.net',
  },
  megafunzone: {
    name: 'MegaFunExploit',
    url: 'http://www.megafunexploit.com',
  },
  randomsite: {
    name: 'Random Garbage',
    url: 'http://www.randomgarbage.net',
  },
};

export const YOUTOOB_VIDEOS = [
  { id: 1, title: 'Chocolate Rain Man Weeps Into Camera',        views: '12,847,293', author: 'TayZonday2007',        youtubeId: 'EwTZ2xpQwpA',  thumbnailPath: 'chocolate-rain.jpg',        duration: '4:55', uploadDate: 'Apr 22, 2007' },
  { id: 2, title: 'Leave Britney Alone 2: Still Monetized',      views: '8,234,102',  author: 'ChrisCries4Revenue', youtubeId: 'WqSTXuJeTks',  thumbnailPath: 'leave-britney-alone.jpg',    duration: '4:02', uploadDate: 'Sep 10, 2007' },
  { id: 3, title: 'Evolution of Selling Out (2007 HD)',           views: '45,123,456', author: 'DanceMaster9000',    youtubeId: 'dMH0bHeiRNg',  thumbnailPath: 'evolution-selling-out.jpg',  duration: '1:30', uploadDate: 'Jan 15, 2007' },
  { id: 4, title: 'Charlie Bit My Finger (Corporate Remix)',      views: '3,456,789',  author: 'BabyBitesBro',       youtubeId: '_OBlgSz8sSM',  thumbnailPath: 'charlie-bit-my-finger.jpg', duration: '0:55', uploadDate: 'May 22, 2007' },
  { id: 5, title: 'Keyboard Cat Plays You Off (Sponsor: Cheetos)',views: '5,678,901',  author: 'CatKeyboardz',       youtubeId: 'J---aiyznGQ',  thumbnailPath: 'keyboard-cat.jpg',          duration: '0:54', uploadDate: 'Jun 7,  2007' },
  { id: 6, title: 'Rick Astley - Never Gonna Give You Up',        views: '18,204,771', author: 'RickAstleyVEVO',     youtubeId: 'dQw4w9WgXcQ',  thumbnailPath: 'rick-astley.jpg',           duration: '3:33', uploadDate: 'Oct 25, 2006' },
];

export const YOUTOOB_COMMENTS = [
  { user: 'xXx_DarkAngel_xXx', text: 'first!!1! watched this 12 times already', likes: 234 },
  { user: 'coolgamer2007', text: 'this is fake but still funny. subscribe back?', likes: 12 },
  { user: 'musiclover99', text: 'best clip this week. upload more please', likes: 567 },
  { user: 'hater4life', text: 'thumbs down from me. old news', likes: 3 },
  { user: 'randomdude123', text: 'who else came here from faceleak?', likes: 89 },
  { user: 'trollmaster', text: 'check my channel for part 2', likes: 0 },
  { user: 'soccermom45', text: 'my kids keep replaying this after school', likes: 45 },
  { user: 'the_real_chad', text: 'i watch 14 hours a day and feel nothing', likes: 156 },
];

export const MYFACE_PROFILES = [
  {
    id: 1,
    name: 'Tom',
    age: 32,
    location: 'Los Angeles, CA (Data Center 7)',
    status: "Hey! I'm Tom. Welcome to FaceLeak. We already know everything.",
    mood: 'monetizing',
    song: 'All Star - Smash Mouth (Brought to you by Cheetos)',
    friends: 8847293,
    topFriends: ['SceneKid420', 'iLoveEmoMusic', 'CoolDude2007'],
    about: "I'm literally everyone's first friend. Your behavioral data is my second income.",
    interests: 'Social Networking, Data Harvesting, Targeted Advertising, Being First',
    bgColor: '#003366',
  },
  {
    id: 2,
    name: 'SceneKid420',
    age: 16,
    location: 'Suburbia, OH',
    status: '~*~RaWr MeAnS i LoVe U iN dInOsAuR~*~',
    mood: 'misunderstood (and tracked)',
    song: 'Welcome to the Black Parade - My Chemical Romance',
    friends: 847,
    topFriends: ['Tom', 'xXx_DarkAngel_xXx', 'BringMeTheHorizon_Fan'],
    about: 'if u cant handle me at my worst u dont deserve me at my best... im not emo im scene theres a difference!!! also this profile was shared with 14 ad partners',
    interests: 'Eyeliner, Hair Straighteners, Taking Mirror Pics, MCR, Unread Privacy Policies',
    bgColor: '#1a0a1a',
  },
  {
    id: 3,
    name: 'iLoveEmoMusic',
    age: 15,
    location: 'Darkness, USA (IP logged)',
    status: 'When I was a young boy, my father took me into the city...',
    mood: 'contemplative (status sold to mood-targeting advertisers)',
    song: 'I Write Sins Not Tragedies - Panic! at the Disco',
    friends: 666,
    topFriends: ['Tom', 'SceneKid420', 'FallOutBoy4Life'],
    about: 'poetry is my escape. nobody understands me except my music and my top friends. leave a comment if u want 2 chat about life and stuff',
    interests: 'Writing Poetry, Crying, Black Clothing, Band Tees, Ignoring Cookie Notices',
    bgColor: '#0d0d0d',
  },
];

export const WINAMP_TRACKS = [
  { id: 1, title: 'Totally_Not_Pirated_Song.mp3', artist: 'Unknown (Subpoena Pending)', size: '4.2 MB', status: 'downloaded', youtubeId: 'dQw4w9WgXcQ' },
  { id: 2, title: 'Linkin Park - But Slightly Different.mp3', artist: 'Linken Pork', size: '3.8 MB', status: 'downloading', youtubeId: 'eVTXPUF4Oz4' },
  { id: 3, title: 'definitely-not-a-virus.exe', artist: 'WinScam Records', size: '0.3 MB', status: 'warning', youtubeId: 'dQw4w9WgXcQ' },
  { id: 4, title: 'Soulja Boi - Crank Dat (REAL THIS TIME).mp3', artist: 'Soulja Boi', size: '5.1 MB', status: 'downloaded', youtubeId: '8UFIYGkROII' },
  { id: 5, title: 'umbrella-rihanna-final-FINAL-v2-THISONE.mp3', artist: 'Rhianna', size: '4.5 MB', status: 'downloaded', youtubeId: 'CvBfHwUxHIk' },
  { id: 6, title: 'My Chemical Romance - Full Album.zip (RIAA watching)', artist: 'MCR', size: '87.3 MB', status: 'seeding', youtubeId: 'RRKJiM9Njr8' },
  { id: 7, title: 'FREE_MOVIE_totally_legal_notavirus.avi', artist: 'Profit Dynamics Intl™', size: '1.2 GB', status: 'error', youtubeId: 'J---aiyznGQ' },
  { id: 8, title: 'avril_lavigne_girlfriend_HQ_FINAL.mp3', artist: 'Avril Lavinge', size: '4.0 MB', status: 'downloaded', youtubeId: 'Bg59q4puhmg' },
];

export const MEGAFUNZONE_GAMES = [
  { id: 1, name: 'Super Brick Breaker Deluxe', plays: '2.3M', rating: 4.5, category: 'Arcade', icon: 'BRK' },
  { id: 2, name: 'Extreme Office Worker Simulator', plays: '1.8M', rating: 4.2, category: 'Simulation', icon: 'SIM' },
  { id: 3, name: 'Escape the Dial-Up Modem', plays: '3.1M', rating: 4.8, category: 'Puzzle', icon: 'MOD' },
  { id: 4, name: 'Penguin Cafe Dash', plays: '5.7M', rating: 4.7, category: 'Management', icon: 'CAF' },
  { id: 5, name: 'Epic Stick Figure Battle', plays: '4.2M', rating: 4.4, category: 'Action', icon: 'ACT' },
  { id: 6, name: 'Dress Up: Scene Queen Edition', plays: '2.9M', rating: 4.1, category: 'Dress Up', icon: 'DRS' },
  { id: 7, name: 'Tower Defense: Dial-Up Edition', plays: '1.5M', rating: 4.3, category: 'Strategy', icon: 'STR' },
  { id: 8, name: 'RunAway: Medieval Quest', plays: '6.8M', rating: 4.9, category: 'RPG', icon: 'RPG' },
  { id: 9, name: 'Flash Flash Revolution', plays: '3.4M', rating: 4.6, category: 'Music', icon: 'MUS' },
  { id: 10, name: 'Helicopter Avoider 3000', plays: '2.1M', rating: 4.0, category: 'Arcade', icon: 'HEL' },
];

export const BANNER_ADS = [
  { id: 1, text: 'YOU ARE THE 1,000,000th VISITOR', subtext: 'Click here to claim your free desktop toolbar', color: '#cc0000' },
  { id: 2, text: 'PRIVACY TOOLS FOR HOME PCS', subtext: 'Upgrade to Plus and remove banner ads', color: '#005500' },
  { id: 3, text: 'Hot Singles In Your Area', subtext: 'Join now with your e-mail address', color: '#880066' },
  { id: 4, text: 'PC PROTECTION ALERT', subtext: 'Your computer may be at risk. Scan now.', color: '#886600' },
  { id: 5, text: 'Escape Reality for FREE', subtext: 'Play games online with no download required', color: '#003388' },
  { id: 6, text: 'One Weird Trick for Better Credit', subtext: 'Approved by 9 out of 10 experts', color: '#884400' },
  { id: 7, text: 'FREE Ringtones for Your Phone', subtext: 'Enter your number to get started', color: '#550088' },
  { id: 8, text: 'Upgrade to Premium Internet™', subtext: 'Faster browsing and fewer pop-up ads', color: '#007744' },
];

export const RANDOM_SITES = [
  { name: 'Hampster Dance', content: 'hamster', description: 'Da ba dee da ba die...' },
  { name: 'All Your Base', content: 'base', description: 'All your base are belong to us' },
  { name: 'Badger Badger', content: 'badger', description: 'Badger badger badger MUSHROOM MUSHROOM' },
  { name: 'Peanut Butter Jelly Time', content: 'pbj', description: 'Its peanut butter jelly time!' },
  { name: 'Star Wars Kid Fan Site', content: 'starwars', description: 'The force is strong with this one' },
  { name: 'Homestar Runner', content: 'homestar', description: 'Everybody! Everybody!' },
];
